import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { FormField, FormFieldContainer } from '../../../components/FormElements';
import { ContentTitle, ContinueButton, ViewContainer } from './OnboardingElements';

type EmailViewProps = {
  handler: (email: string) => void;
  storedEmail?: string;
};

export const EmailView = ({ storedEmail = '', handler }: EmailViewProps) => {
  const submit = ({ email }: { email: string }) => handler(email);

  return (
    <>
      <ContentTitle>
        <h2>Enter Your Email Address</h2>
        <p>Provide the email address you want to link to the preview</p>
      </ContentTitle>
      <ViewContainer>
        <Formik
          initialValues={{ email: storedEmail }}
          validationSchema={Yup.object({
            email: Yup.string().email('Invalid email address').required('An email address is required'),
          })}
          validateOnChange={false}
          onSubmit={submit}
        >
          {({ isSubmitting }) => (
            <Form>
              <FormFieldContainer>
                <FormField label="Email Address" name="email" type="text" placeholder="Enter Email Address" />
              </FormFieldContainer>

              <div className="grid-container grid-content-center mt-64">
                <ContinueButton
                  data-qa-hook="continueButton"
                  type="submit"
                  disabled={isSubmitting}
                  operating={isSubmitting}
                >
                  Continue
                </ContinueButton>
              </div>
            </Form>
          )}
        </Formik>
      </ViewContainer>
    </>
  );
};
